import { render, staticRenderFns } from "./JourneyBuilderMenuEditForm.vue?vue&type=template&id=02216a58&"
import script from "./JourneyBuilderMenuEditForm.vue?vue&type=script&lang=js&"
export * from "./JourneyBuilderMenuEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02216a58')) {
      api.createRecord('02216a58', component.options)
    } else {
      api.reload('02216a58', component.options)
    }
    module.hot.accept("./JourneyBuilderMenuEditForm.vue?vue&type=template&id=02216a58&", function () {
      api.rerender('02216a58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Menu/JourneyBuilderMenuEditForm.vue"
export default component.exports